import PrimaryButton from "components/buttons/primary-button";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  value: string;
  setValue: (value: string) => void;
  saveLyrics: () => void;
  loading: boolean;
}
const LyricsInput = ({ value, setValue, saveLyrics, loading }: IProps) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const handleInput = (event: any) => {
    const textarea = event.target;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
    setValue(textarea.value);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();

      inputRef.current.style.height = "auto";
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  }, []);

  return (
    <Container>
      <Input
        ref={inputRef}
        placeholder="Enter your songs lyrics here"
        value={value}
        onInput={handleInput}
      />
      <SaveContainer>
        <ButtonContainer>
          <PrimaryButton
            text="Save Lyrics"
            disabled={value.length === 0 || loading}
            onClick={() => saveLyrics()}
            loading={loading}
          />
        </ButtonContainer>
      </SaveContainer>
    </Container>
  );
};

export default LyricsInput;

const Container = styled.div`
  margin-top: 2rem;
  width: 100%;
  height: fit-content;
`;

const Input = styled.textarea`
  caret-color: ${Colors.yellow500};
  width: 100%;
  background-color: transparent;
  border: none;
  font-size: 1.4rem;
  min-height: 50rem;
  resize: none;
  overflow: hidden;
  color: ${Colors.grey300};
  font-family: "Switzer", sans-serif;
  &::placeholder {
    color: ${Colors.grey600};
  }
  &:focus {
    border: none;
    outline: none;
  }

  @media only screen and (max-width: 769px) {
    font-size: 1.2rem;
  }
`;

const SaveContainer = styled.div`
  width: 100%;
  margin-top: 2rem;
  padding: 1.4rem 6.4rem;
  padding-bottom: 0;
  border-top: 1px solid ${Colors.grey700};
  @media only screen and (max-width: 769px) {
    padding: 1.4rem;
  }
`;

const ButtonContainer = styled.div`
  width: fit-content;
  margin-left: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
